var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "comp-info-iconb",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1342",
    "data-name": "Rectangle 1342",
    width: 30,
    height: 30,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "info_FILL0_wght400_GRAD0_opsz48",
    d: "M14.257,20.5h1.65V13.9h-1.65ZM15,11.865a.9.9,0,0,0,.646-.248.833.833,0,0,0,.261-.632.924.924,0,0,0-.261-.66.9.9,0,0,0-1.293,0,.924.924,0,0,0-.261.66.833.833,0,0,0,.261.632.9.9,0,0,0,.646.248ZM15,26a10.644,10.644,0,0,1-4.262-.866,11.083,11.083,0,0,1-5.871-5.871,10.988,10.988,0,0,1,0-8.553A10.993,10.993,0,0,1,7.231,7.218a11.276,11.276,0,0,1,3.506-2.351,10.988,10.988,0,0,1,8.553,0,10.983,10.983,0,0,1,5.844,5.844,10.988,10.988,0,0,1,0,8.553,11.276,11.276,0,0,1-2.351,3.506,10.993,10.993,0,0,1-3.492,2.365A10.711,10.711,0,0,1,15,26Zm.027-1.65a8.965,8.965,0,0,0,6.6-2.736,9.066,9.066,0,0,0,2.722-6.641,8.988,8.988,0,0,0-2.722-6.6A9.02,9.02,0,0,0,15,5.65,9.033,9.033,0,0,0,8.386,8.372,9,9,0,0,0,5.65,15a9.01,9.01,0,0,0,2.736,6.614A9.043,9.043,0,0,0,15.027,24.35ZM15,15Z",
    transform: "translate(0)",
    fill: "rgba(0,0,0,0.6)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoicon);
export default __webpack_public_path__ + "static/media/Infoicon.3eb93e51eccbd78893291a01d29044b4.svg";
export { ForwardRef as ReactComponent };